<script>
	import { Router, Route } from "svelte-navigator";
	import Intro from "./pages/Intro.svelte";
	import Home from "./pages/Home.svelte";
	import About from "./pages/About.svelte";
	import FacialExpressions from "./pages/FacialExpressions.svelte";
	import Games from "./pages/Games.svelte";

	import Bloom from "./pages/Bloom.svelte";
	import Pump from "./pages/Pump.svelte";
	import Saw from "./pages/Saw.svelte";
	// import BloomDemo from "./pages/demo/BloomDemo.svelte";
	// import SawDemo from "./pages/demo/SawDemo.svelte";
	// import PumpDemo from "./pages/demo/PumpDemo.svelte";
</script>

<Router>
	<Route path="/" component={Intro} />
	<Route path="home" component={Home} />
	<Route path="about" component={About} />
	<Route path="face-expression" component={FacialExpressions} />
	<Route path="games" component={Games} />
	<Route path='game/bloom' component={Bloom} />
	<Route path='game/pump' component={Pump} />
	<Route path='game/saw' component={Saw} />
	<!-- <Route path='bloom-demo' component={BloomDemo} />
	<Route path='saw-demo' component={SawDemo} />
	<Route path='pump-demo' component={PumpDemo} /> -->
</Router>

<style lang="scss" global>
  @import "./scss/style.scss";
</style>